import React, { useMemo} from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing'
import CoverityCredentialsForm from './CoverityCredentialsForm'
import CoverityMappingForm from './CoverityMappingForm'
import { CellRenderers } from 'utils/tableUtils';

export default function CoverityConfigListing(props) {
    const columns = useMemo(()=> [
        {
            title: "Project",
            dataIndex: "projectName",
            width: 240,
            render: CellRenderers.VALUE_OR_NA
        },
        {
            title: "Stream Name",
            dataIndex: "streamName",
            width: 240,
            render: CellRenderers.VALUE_OR_NA
        }
    ],[])
    return (
        <GenericPullConfigListing
            {...props}
            toolName={props.name}
            MappingForm={CoverityMappingForm}
            CredentialsForm={CoverityCredentialsForm}
            extraColumns={columns}
        />
    )
}
